import { ToastLevel } from '@philips-emr/tws-constants';
import { FileService } from '@philips-emr/tws-core/lib/services';

import { ToastService } from './toast-service';

interface Download {
  endpoint: string,
  name?: string;
  parameters?: {},
}

class DownloadService {

  static of(arg: Download): void {
    const { endpoint, name, parameters } = arg;

    ToastService.open({ message: 'provider.download-started', level: ToastLevel.INFORMATION });

    FileService.download(endpoint, name, parameters)
      .catch(() => ToastService.open({ message: 'provider.file-not-found', level: ToastLevel.CAUTION }));
  }
}

export {
  DownloadService,
};
